// import { Bars3Icon } from "@heroicons/react/24/solid";
import Hamburger from 'hamburger-react'
import bala_resume from "../assets/pdf/Balavigneshwaran p_resume.pdf";
import React from "react";
import { useState } from "react";
import { useEffect } from 'react';
import {
  HomeIcon as HomeOutline,
  UserIcon as UserOutline,
  LightBulbIcon as SkillOutline,
  BriefcaseIcon as ProjectOutline,
  PhoneIcon as ContactOutline,
  DocumentIcon as DocumentOutline,
} from "@heroicons/react/24/outline";

import {
  HomeIcon as HomeSolid,
  UserIcon as UserSolid,
  LightBulbIcon as SkillSolid,
  BriefcaseIcon as ProjectSolid,
  PhoneIcon as ContactSolid,
  // DocumentIcon as Documentsolid,

} from "@heroicons/react/24/solid";

export default function Header() {
  const [togglebnt, settogglebnt] = useState(false);
  const [activeSection, setActiveSection] = useState("home", "about");

useEffect(() => {
  const sectionIds = ["home", "about", "skills", "projects", "contact"];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );

  sectionIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) observer.observe(el);
  });

  return () => {
    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.unobserve(el);
    });
  };
}, []);

  return (
    <header className="  flex justify-between text-white px-5 py-2 ">
      <a
        data-aos="fade-down"
        data-aos-duration="2000"
        data-aos-once="true"
        href="https://github.com/BALAVIGNESHWARAN23"
        id="home"
        className="z-10 "
      >
        <h2 className=" font-bold text-3xl  font-boldfont hover:text-orange-500  text-white  ">
          B<span className="hover:text-white text-orange-500 ">V</span>
        </h2>
      </a>
      <nav className="hidden md:block">
        <ul
          data-aos="fade-down"
          data-aos-duration="2000"
          data-aos-once="true"
          className="headermin flex fixed  z-50 font-bold text-2xl font-modernfont"
        >
          <a href="#home">
              <li className="flex hover:text-orange-500 duration-300">
    {activeSection === "home" ? (
      <HomeSolid className="h-5 w-5 mr-1 mt-1" />
    ) : (
      <HomeOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              Home
            </li>
          </a>
          <a href="#about">
             <li className={`flex duration-300 hover:text-orange-500 ${
    activeSection === "about" ? "text-orange-500 text-glow-black" : "bg-transparent"
  }`}>
    {activeSection === "about" ? (
      <UserSolid className="h-5 w-5 mr-1 mt-1 text-orange-500 text-glow-black" />
    ) : (
      <UserOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              About
            </li>
          </a>
          <a href="#skills">
             <li className={`flex duration-300 hover:text-orange-500 ${
    activeSection === "skills" ? "text-orange-500   text-glow-black"  : "bg-transparent"
  }`}>
    {activeSection === "skills" ? (
      
      <SkillSolid className="h-5 w-5 mr-1 mt-1 text-orange-500" />
    ) : (
      <SkillOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              Skills
            </li>
          </a>
          <a href="#projects">
             <li className={`flex duration-300 hover:text-orange-500 ${
    activeSection === "projects" ? "text-orange-500 text-glow-black" : "bg-transparent"
  }`}>
    {activeSection === "projects" ? (
      <ProjectSolid className="h-5 w-5 mr-1 mt-1 text-orange-500 text-glow-black" />
    ) : (
      <ProjectOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              Projects
            </li>
          </a>
          <a href="#contact">
              <li className={`flex duration-300 hover:text-orange-500  ${
    activeSection === "contact" ? "text-orange-500 text-glow-black" : "bg-transparent"
  }`}>
    {activeSection === "contact" ? (
      <ContactSolid className="h-5 w-5 mr-1 mt-1 text-orange-500 text-glow-black" />
    ) : (
      <ContactOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              Contact
            </li>
          </a>
        </ul>
      </nav>
      {togglebnt && (
        <nav className=" block md:hidden  ">
          <ul
            className="flex flex-col font-bold duration-300 mobilnav animate-fade-in-right"
            onClick={() => settogglebnt(!togglebnt)}
          >
            <li className="flex hover:text-orange-500 duration-300">
    {activeSection === "home" ? (
      <HomeSolid className="h-5 w-5 mr-1 mt-1" />
    ) : (
      <HomeOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              <a href="#home">Home</a>
            </li>
           <li className="flex hover:text-orange-500 duration-300">
    {activeSection === "about" ? (
      <UserSolid className="h-5 w-5 mr-1 mt-1 " />
    ) : (
      <UserOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              <a href="#about">About</a>
            </li>
            <li className="flex hover:text-orange-500 duration-300">
    {activeSection === "skills" ? (
      <SkillSolid className="h-5 w-5 mr-1 mt-1" />
    ) : (
      <SkillOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              <a href="#skills">Skills</a>
            </li>
              <li className="flex hover:text-orange-500 duration-300">
    {activeSection === "projects" ? (
      <ProjectSolid className="h-5 w-5 mr-1 mt-1" />
    ) : (
      <ProjectOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              <a href="#projects">Projects</a>
            </li>
           <li className="flex hover:text-orange-500 duration-300">
     <DocumentOutline className="h-5 w-5 mr-1 mt-1" />
              <a href={bala_resume}>Resume</a>
            </li>
             <li className="flex hover:text-orange-500 duration-300">
    {activeSection === "contact" ? (
      <ContactSolid className="h-5 w-5 mr-1 mt-1" />
    ) : (
      <ContactOutline className="h-5 w-5 mr-1 mt-1" />
    )}
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </nav>
      )}
      <button onClick={() => settogglebnt(!togglebnt)}>

        {/* <Bars3Icon className=" fixed right-6 top-4 block md:hidden mobilnav1 text-white hover:text-orange-500 font-boldfont h-6 " /> */}
       <div className="fixed right-6   top-1 block md:hidden lg:hidden z-50">
  <Hamburger
    toggled={togglebnt}
    toggle={settogglebnt}
    size={29}
    color={togglebnt ? "#f97316" : "#ffffff"}
    direction="right"
    rounded
  />
</div>   
   </button>
    </header>
  );
}
